import { render, staticRenderFns } from "./InboxView.vue?vue&type=template&id=b899b4e6&scoped=true&"
import script from "./InboxView.vue?vue&type=script&lang=js&"
export * from "./InboxView.vue?vue&type=script&lang=js&"
import style0 from "./InboxView.vue?vue&type=style&index=0&id=b899b4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899b4e6",
  null
  
)

export default component.exports